import React from 'react'
import ProductsShortsLower from './ProductsShortsLower'


export default function ShortsLower() {
  return (
    <div>
        <ProductsShortsLower/>
    </div>
  )
}
